import { useMutation } from '@tanstack/react-query';

import { DeleteVoucherResponse, deleteVoucher } from '~/services/PromoService';

export function useDeleteVoucher() {
  return useMutation<DeleteVoucherResponse, Error, string>({
    mutationFn: async (voucherId) => deleteVoucher(voucherId),
  });
}
